import initializeDisplayPreferencesButtons from './initializeDisplayPreferencesButtons'

export default initializeDisplayPreferencesButtons
